import en from './en.json';
import fr from './fr.json';
import es from './es.json';
import esMX from './es-MX.json';
import de from './de.json';
import ja from './ja.json';
import zhCN from './zh-CN.json';
import ptBR from './pt-BR.json';
import ru from './ru.json';
import ko from './ko.json';
import it from './it.json';
import nl from './nl.json';
import tr from './tr.json';
import ar from './ar.json';

export const locales = {
  en,
  fr,
  es,
  'es-MX': esMX,
  de,
  ja,
  'zh-CN': zhCN,
  'pt-BR': ptBR,
  ru,
  ko,
  it,
  nl,
  tr,
  ar,
} as const;

export const supportedLanguages = Object.keys(locales) as SupportedLanguage[];

export type SupportedLanguage = keyof typeof locales;

const rtlLanguages = ['ar', 'he', 'fa', 'ur'];

export function isRTL(language: string): boolean {
  return rtlLanguages.includes(language);
}
